import documents from './documents/actions';
import normalizer from './normalizer/actions';
import app from './app/actions';
import modal from './modal/actions';
import user from './user/actions';
import configurator from './configurator/actions';
import userReportSettings from './userReportSettings/actions';
import chatbot from './chatbot/actions';

export default {
  app,
  modal,
  user,
  documents,
  normalizer,
  configurator,
  userReportSettings,
  chatbot,
};
